import { render, staticRenderFns } from "./SpeechAlertTextEditor.vue?vue&type=template&id=2895d661&scoped=true&"
import script from "./SpeechAlertTextEditor.vue?vue&type=script&lang=js&"
export * from "./SpeechAlertTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlertTextEditor.vue?vue&type=style&index=0&id=2895d661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895d661",
  null
  
)

export default component.exports